/**
 * Copy to clipboard function
 *
 * @param {string} str String to be copied to clipboard
 * @return void
 *
 */
export default function(str) {
  if ("clipboard" in navigator) {
    navigator.clipboard
      .writeText(str)
      .then(() => {
        console.log("copied");
      })
      .catch(err => {
        console.error(err);
      });
  }
}
